import ApiService from './ApiService'

const Me = () => {

    return ApiService.post(`${process.env.REACT_APP_APILOGIN}Usuario/Me`);
}

export default {Me};